<template>
  <el-select
    v-model="ids"
    v-loadmore="loadMore"
    :multiple="multiple"
    filterable
    remote
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="selectLoading"
    :disabled="disabled"
    clearable
    @focus="handleFocus"
  >
    <el-option
      v-for="item in employeeList"
      :key="item.employeeId"
      :label="item.name"
      :value="item.employeeId"
    >
      <span>
        {{ item.name }} / {{ item.mobile }}
        <template v-if="!onlyShowName">
          {{ item.companyName && `/ ${item.companyName}` }}
          {{ item.deptName && `/ ${item.deptName}` }}
        </template>
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { getEmployeeByNameApi, getEmployeeListApi } from '@/api/company'

import { cloneDeep, uniqBy } from 'lodash'

export default {
  // 员工异步选择框
  name: 'EmployeeAsyncSelect',

  model: {
    prop: 'employee',
    event: 'change'
  },

  props: {
    placeholder: {
      type: String,
      default: ''
    },

    employee: {
      type: [Array, Number, String],
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    echoList: {
      type: Array,
      default: () => []
    },

    // 是否只查询本公司的员工（是否不包含下属公司员工）默认包含下属公司员工
    onlyCompanyEmployee: {
      type: Boolean,
      default: false
    },

    searchKey: {
      type: String,
      default: 'employeeName'
    },

    // 固定搜索某一个部门的员工
    deptId: {
      type: [String, Number],
      default: ''
    },

    // 单选还是多选
    multiple: {
      type: Boolean,
      default: true
    },

    // 只展示员工姓名
    onlyShowName: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: [],
      size: 20,
      page: 1,
      employeeName: '', // 当单选的时候，返回员工名称
      selectLoading: false,
      searchKeyword: '', // 当前搜索的关键字

      firstFocus: true // 第一次获取焦点
    }
  },

  computed: {
    ids: {
      get() {
        return cloneDeep(this.employee)
      },
      set(val) {
        if (!this.multiple) {
          const employeeItem = this.options.find(k => k.employeeId === val)
          this.$emit('setEmployeeName', employeeItem?.name || '')
        }
        this.$emit('change', val)
      }
    },

    employeeList() {
      const arr = [
        ...this.echoList
          .map(value => {
            if (
              this.options.includes(
                option => option.employeeId === value.employeeId
              )
            ) {
              return undefined
            } else {
              return value
            }
          })
          .filter(value => value),
        ...this.options
      ]

      return uniqBy(arr, 'employeeId')
    }
  },

  methods: {
    remoteMethod(query, needLoading = true) {
      if (!this.onlyCompanyEmployee && !query) return Promise.resolve()

      if (this.searchKeyword !== query) {
        this.searchKeyword = query
        this.options = []
        this.page = 1
      }

      needLoading && (this.selectLoading = true)

      const requestApi = this.onlyCompanyEmployee
        ? getEmployeeListApi
        : getEmployeeByNameApi

      const params = {
        page: this.page,
        size: this.size,
        deptId: this.deptId,
        status: 1
      }
      if (this.onlyCompanyEmployee) {
        params[this.searchKey] = this.searchKeyword || ''
      } else {
        params.name = this.searchKeyword || ''
      }

      return requestApi(params)
        .then(res => {
          const data = res.data || {}
          this.total = data?.total
          this.options.push(
            ...(data.records || []).map(value => {
              return {
                employeeId: value.employeeId,
                name: value.employeeName || value.name,
                mobile: value.mobile || '',
                companyName: value.companyName,
                deptName: value.deptName
              }
            })
          )
        })
        .catch(err => {
          if (err) {
            this.$message.error(err.message || '查询失败')
          }
        })
        .finally(() => {
          needLoading && (this.selectLoading = false)
        })
    },

    // 当选择框获取焦点时
    handleFocus() {
      if (!this.firstFocus) return
      this.firstFocus = false
      this.remoteMethod(this.searchKeyword, true)
    },

    // 获取更多的员工列表
    loadMore() {
      // 如果没有更多数据，则不请求
      if (this.total <= this.options.length) return

      // 如果intercept属性为true则不请求数据
      if (this.loadMore.intercept) return

      this.loadMore.intercept = true
      this.page += 1
      this.remoteMethod(this.searchKeyword)
        .catch(() => {
          this.page--
        })
        .finally(() => {
          this.loadMore.intercept = false
        })
    }
  }
}
</script>

<style scoped></style>
